<div class="sub-title">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.DESCRIPTION' | translate }}
</div>
<automata-automation-replacement-chips
  label="AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CONDITION"
  [dataService]="lastEditActionConditionDataService"
  [formControl]="lastEditActionConditionControl"
  [supportDataPassing]="false"
  [isRequired]="true"
  [multiple]="false"
></automata-automation-replacement-chips>

<ng-container *ngIf="lastEditActionConditionControl.value !== LastEditActionCondition.Closed">
  <ng-container *ngTemplateOutlet="pipelineSelectorTemplate"></ng-container>
</ng-container>

<ng-container *ngIf="lastEditActionConditionControl.value === LastEditActionCondition.Closed">
  <ng-container *ngTemplateOutlet="closedStatus"></ng-container>
</ng-container>

<ng-template #pipelineSelectorTemplate>
  <ng-container *ngIf="(disablePipelineAndStageSelection$ | async) === false">
    <ng-container *ngIf="initialPipelineId">
      <div class="sub-title">
        {{ 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.AND_IS_IN_PIPELINE_AT_STAGE' | translate }}
      </div>
      <automata-pipeline-selector
        class="form-input"
        #pipelineSelector
        [required]="true"
        [selectedPipelineId]="initialPipelineId"
        [selectedStageId]="initialStageId"
      ></automata-pipeline-selector>
    </ng-container>
    <ng-container *ngIf="!initialPipelineId">
      <div class="filter-alert">{{ 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.FILTER_DISCLAIMER' | translate }}</div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #closedStatus>
  <ng-container *ngIf="closedPipelineControl.value">
    <div class="sub-title">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.AND_IS_IN_PIPELINE' | translate }}
    </div>
    <automata-automation-replacement-chips
      label="AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.PIPELINE"
      [dataService]="salesOpportunitiesService"
      [formControl]="closedPipelineControl"
      [supportDataPassing]="false"
      [isRequired]="(disablePipelineAndStageSelection$ | async) === false"
      [multiple]="false"
      [extraData]="{ prependAnyOption: true }"
    ></automata-automation-replacement-chips>
  </ng-container>

  <div class="sub-title">
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.AND_HAS_STATUS' | translate }}
  </div>
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.STATUS"
    [dataService]="opportunityStatusDataService"
    [formControl]="opportunityStatusControl"
    [supportDataPassing]="false"
    [isRequired]="true"
    [multiple]="false"
  ></automata-automation-replacement-chips>

  <ng-container *ngIf="opportunityStatusControl.value === OpportunityStatus.ClosedLost">
    <div class="sub-title">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.AND_HAS_CLOSED_LOST_REASON' | translate }}
    </div>
    <automata-automation-replacement-chips
      label="AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON"
      [dataService]="closedLostReasonDataService"
      [formControl]="closedLostReasonControl"
      [supportDataPassing]="false"
      [isRequired]="true"
      [multiple]="false"
    ></automata-automation-replacement-chips>
  </ng-container>

  <ng-container *ngIf="!closedPipelineControl.value">
    <div class="filter-alert">{{ 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.FILTER_DISCLAIMER' | translate }}</div>
  </ng-container>
</ng-template>
